module.exports = __webpack_public_path__ + "img/hand-sparkles.db214f20.svg";